export default {
  no_image: '身分証明書の画像が添付されていません(WebError)',
  message_null: 'メッセージが空です(WebError)',
  save_fail: '保存失敗(WebError)',
  validate_password: 'パスワードは半角数字6桁で入力して下さい(WebError)',
  validate_fullname_contact: 'お名前を入力してください(WebError)',
  validate_email_contact: 'メールアドレスを入力してください(WebError)',
  validate_phone: '電話番号を入力してください(WebError)',
  validate_gender: '性別を入力してください(WebError)',
  validate_nickname: 'ニックネームを入力してください(WebError)',
  validate_nickname_length: 'ニックネームは10文字以内で入力してください(WebError)',
  validate_year: '年を入力してください(WebError)',
  validate_month: '月を入力してください(WebError)',
  validate_day: '日を入力してください(WebError)',
  validate_address: '都道府県を入力してください(WebError)',
  validate_age: '18歳未満の人のユーザー登録はできません(WebError)',
  validate_title_contact: '問い合わせ内容を選択してください(WebError)',
  validate_content_contact: '本文を入力してください(WebError)',
  validate_phone_contact_format: '電話番号は半角数字で入力して下さい(WebError)',
  validate_email_contact_format: 'メールの形式が正しくありません(WebError)',
  validate_agree: 'プライバシーポリシーに同意するにチェックが入っていません(WebError)',
  validate_katakana: 'お名前のフリガナはカタカナで入力して下さい(WebError)'
};
